__webpack_require__.p = "https://mlb-play.mlbstatic.com/apps/player-of-the-game/game/";